import { imageAsset } from '@/data/sanity/fragments'
import giftCardCategory from './giftCardCategory'
import { getLanguageQueryString } from '@/data/sanity/utils-language'

export const fields = `
  _id,
  _type,
  title,
  image {
    ${imageAsset.fieldsWithDataUri}
  },
  ...(content) {
    ${getLanguageQueryString([
      'faceplateCode',
      'altText',
      { name: 'giftCardCategories', dereference: true, isArray: true, fields: giftCardCategory.fields },
      'physicalCardAvailability',
      {
        name: 'temporaryPhysicalDateRange',
        fields: `
        startDate,
        endDate
        `,
      },
      'digitalCardAvailability',
      {
        name: 'temporaryDigitalDateRange',
        fields: `
        startDate,
        endDate
        `,
      },
    ])}
  }
`

export const fragment = (name = 'giftCardFaceplate') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
